module.exports = __webpack_public_path__ + "static/background-hero-athletico-paranaense-mobile-4b0aa572b45d5b243a0cbe711755efa5.jpg";